import { Dropdown } from 'primereact/dropdown';
import React from 'react';
import { Controller } from 'react-hook-form';
import { showFormErrorMessage } from 'modules/billing/TemporaryFund/helpers/temporaryFundHelpers';
import { formValidationOptions } from 'modules/billing/TemporaryFund/configs/temporaryFundConfigs';

const TemporaryFundPaymentMethod = (props) => {
  const { control, errors, isWithdraw } = props;

  const paymentMethodOptions = isWithdraw
    ? [
        { label: 'Designated to Temporary Trust Funds', value: 'transfer_in_trust_account' },
        { label: 'To Client', value: 'to_client' },
      ]
    : [
        { label: 'Transfer from Trust Account', value: 'transfer_from_trust_account' },
        { label: 'Cheque Payment', value: 'cheque_payment' },
      ];

  return (
    <div className="d-flex align-items-top py-2 flex-wrap">
      <div className="col-12 col-sm-4 pt-2">
        Payment Method<span className="alert-star">*</span>
      </div>
      <div className="col-12 col-sm-8 pt-2">
        <Controller
          control={control}
          name={formValidationOptions?.paymentMethod?.name}
          rules={formValidationOptions?.paymentMethod?.rules}
          render={({ field }) => (
            <Dropdown
              className="input-shadow w-100 p-0"
              placeholder="Select Payment Method"
              options={paymentMethodOptions}
              name={field?.name}
              value={field?.value}
              onChange={(e) => field.onChange(e.value)}
              optionLabel="label"
              optionValue="value"
            />
          )}
        />
        {showFormErrorMessage(formValidationOptions?.paymentMethod?.name, errors)}
      </div>
    </div>
  );
};

export default TemporaryFundPaymentMethod;
